import { render } from "./ProductCategoryBulkUpdateButton.vue?vue&type=template&id=7d70dce2"
import script from "./ProductCategoryBulkUpdateButton.vue?vue&type=script&lang=js"
export * from "./ProductCategoryBulkUpdateButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__